import bridgeV1 from "./versionedFiles/v1-bridge-09-12-2024";
import bridgeV2 from "./versionedFiles/v2-bridge-25-03-2026";

import dscrV1 from "./versionedFiles/v1-dscr-09-12-2024";
import dscrV2 from "./versionedFiles/v2-dscr-22-04-2026";

import { BRIDGE_V1_ID, DSCR_V1_ID, BRIDGE_V2_ID, DSCR_V2_ID } from "./versionedFiles/versions";

const VersionedFields = {
  [BRIDGE_V1_ID]: bridgeV1,
  [BRIDGE_V2_ID]: bridgeV2,
  [DSCR_V1_ID]: dscrV1,
  [DSCR_V2_ID]: dscrV2,
};

export type VersionKeys = keyof typeof VersionedFields;

export const latestVersions: Record<"bridge" | "dscr", VersionKeys> = {
  bridge: BRIDGE_V2_ID,
  dscr: DSCR_V2_ID,
};

export default VersionedFields;